import storage from "@/utils/storage";

import Vue from "vue";
import App from "./App.vue";
import store from "./store";
import router from "./router";
import plugins from "./plugins";

import ElementUI from "element-ui";
import "@/assets/styles/element-variables.scss";
import "@/assets/styles/index.scss";
import "@/assets/styles/ruoyi.scss";

import uploader from "vue-simple-uploader";

import { parseTime, resetForm } from "@/utils";

// 全局处理：为表格中 disabled 的输入框自动添加 title 属性以支持 tooltip
function updateTableTooltips() {
    // 查找所有表格中 disabled 的 input
    const disabledInputs = document.querySelectorAll('.el-table .el-input.is-disabled .el-input__inner, .el-table .el-select.is-disabled .el-input__inner');
    
    disabledInputs.forEach(input => {
        const value = input.value || '';
        if (value.trim()) {
            input.setAttribute('title', value);
        } else {
            input.removeAttribute('title');
        }
    });
}

function initVueApp() {
    Vue.prototype.parseTime = parseTime;
    Vue.prototype.resetForm = resetForm;
    Vue.prototype.storage = storage;
    Vue.use(ElementUI);
    Vue.use(uploader);
    Vue.use(plugins);

    Vue.config.productionTip = false;

    const app = new Vue({
        router,
        store,
        el: "#app",
        render: (h) => h(App)
    });

    // 在应用挂载后，定期更新 tooltip（当数据变化时）
    app.$nextTick(() => {
        updateTableTooltips();
        
        // 使用 MutationObserver 监听 DOM 变化，自动更新 tooltip
        if (typeof MutationObserver !== 'undefined') {
            const observer = new MutationObserver(() => {
                updateTableTooltips();
            });
            
            observer.observe(document.body, {
                childList: true,
                subtree: true,
                attributes: true,
                attributeFilter: ['value', 'class']
            });
        }
    });
    
    return app;
}

if (!sessionStorage.getItem("client-userInfo") || !sessionStorage.getItem("Authorization")) {
    sessionStorage.removeItem("client-userInfo");
    sessionStorage.removeItem("Authorization");
    localStorage.clear();
    window.location.href = process.env.VUE_APP_KW_AUTH_BASE_URL + "enterpriseAuth/goLogin?systemType=cxqComClient";
} else {
    initVueApp();
}
//initVueApp();
